<!--
 * @Desc: 面包屑
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-06 11:01:06
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div id="breadCrumb" :style="'background-image: url(' + $adddom(objectData.thu) + ');'">
        <div class="container">
            <div class="title">{{ objectData.title }}</div>
            <div class="bread-crumb">
                <div v-for="(item, idx) in objectData.navArray">
                    <span v-show="idx != 0">·</span>{{ item.name }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            imageUrl: require("../../../public/statics/images/Banner/banner1.jpg"),
        };
    },
    props: ["objectData"],
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {},
    mounted: function () {},
    methods: {},
};
</script>

<style scoped>
#breadCrumb {
    min-width: 1200px;
    width: 100%;
    height: 535px;
    background: #f0f2f5 no-repeat top center;
    background-size: cover;
    /* display: flex;
    align-items: center; */
}
#breadCrumb .container {
    padding-top: 400px;
}
#breadCrumb .container .title {
    height: 40px;
    font-size: 40px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    vertical-align: middle;
    padding-left: 45px;
    margin-bottom: 24px;
}
#breadCrumb .container .bread-crumb {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    vertical-align: top;
    width: 840px;
    height: 70px;
    background: url(../../../public/statics/images/BreadCrumb/breadCrumb-bg.png)
        no-repeat;
    display: flex;
    align-items: center;
    padding-left: 45px;
}
#breadCrumb .container .bread-crumb span {
    display: inline-block;
    margin: 0 10px;
}
</style>
